var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-layout",
        { staticClass: "overflow p20", attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { staticClass: "total-sales", attrs: { xs12: "", md12: "" } },
            [
              _c("h1", [
                _vm._v("Total Sales - $" + _vm._s(_vm.totalSales.toFixed(2)))
              ])
            ]
          ),
          _vm._v(" "),
          _c("v-flex", { attrs: { xs12: "", md6: "" } }, [
            _c("h2", [
              _vm._v(
                "Online Orders - $" + _vm._s(_vm.onlineOrderTotal.toFixed(2))
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs12: "", md6: "" } },
            [
              _c("h2", [
                _vm._v(
                  "Manual Orders - $" + _vm._s(_vm.manualOrderTotal.toFixed(2))
                )
              ]),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  on: {
                    click: function($event) {
                      ;(_vm.showUserWise = !_vm.showUserWise),
                        (_vm.moreless = _vm.showUserWise ? "Less" : "More")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.moreless))]
              ),
              _vm._v(" "),
              _vm.showUserWise
                ? _c(
                    "div",
                    _vm._l(this.userwiseSales, function(order, user) {
                      return _c("v-flex", { key: user }, [
                        _c("h3", [
                          _vm._v(
                            _vm._s(user) + " - $" + _vm._s(order.toFixed(2))
                          )
                        ])
                      ])
                    }),
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0ed428fe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ed428fe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AgendaModal.vue
// module id = null
// module chunks = 